import EmblaCarousel from 'embla';
import EmblaCarouselAutoplay from 'embla-autoplay';
import EmblaCarouselAutoscroll from 'embla-autoscroll';

export class EmblaCarouselElement extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.autoScroll = this.container?.getAttribute('data-autoscroll') === 'true';
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.embla = EmblaCarousel(this.container, {
      loop: true,
      align: 'start',
      dragFree: this.autoScroll
    }, this.autoScroll ? [
      EmblaCarouselAutoscroll({
        speed: 0.5,
        startDelay: 0,
        stopOnMouseEnter: true,
        stopOnInteraction: false,
        stopOnFocusIn: false
      })
    ] : [
      EmblaCarouselAutoplay({
        startDelay: 0,
        delay: 6000
      })
    ]);
  }
}

if (!customElements.get('embla-carousel')) {
  customElements.define('embla-carousel', EmblaCarouselElement);
}